import React, { createContext, useContext, useReducer, ReactNode } from 'react';
import {
  LicitacaoDetailsState,
  LicitacaoDetailsAction,
  LicitacaoDetailsReducer,
} from './licitacao-details-reducer';

const initialState: LicitacaoDetailsState = {
  licitacaoDetails: null,
  loading: false,
  error: null,
};

const LicitacaoDetailsStateContext = createContext<LicitacaoDetailsState | undefined>(undefined);
const LicitacaoDetailsDispatchContext = createContext<React.Dispatch<LicitacaoDetailsAction> | undefined>(undefined);

interface LicitacaoDetailsProviderProps {
  children: ReactNode;
}

export const LicitacaoDetailsProvider: React.FC<LicitacaoDetailsProviderProps> = ({ children }) => {
  const [state, dispatch] = useReducer(LicitacaoDetailsReducer, initialState);

  return (
    <LicitacaoDetailsStateContext.Provider value={state}>
      <LicitacaoDetailsDispatchContext.Provider value={dispatch}>
        {children}
      </LicitacaoDetailsDispatchContext.Provider>
    </LicitacaoDetailsStateContext.Provider>
  );
};

export const useLicitacaoDetailsState = (): LicitacaoDetailsState => {
  const context = useContext(LicitacaoDetailsStateContext);
  if (context === undefined) {
    throw new Error('useLicitacaoDetailsState must be used within a LicitacaoDetailsProvider');
  }
  return context;
};

export const useLicitacaoDetailsDispatch = (): React.Dispatch<LicitacaoDetailsAction> => {
  const context = useContext(LicitacaoDetailsDispatchContext);
  if (context === undefined) {
    throw new Error('useLicitacaoDetailsDispatch must be used within a LicitacaoDetailsProvider');
  }
  return context;
};
